/**
 * One line per thing the coins were flipped for, in the order they were flipped: "Thunder Jolt: tails",
 * "Twineedle: heads, tails".
 *
 * @param {Array<{label: string, heads: boolean}>} flips
 * @returns {string[]}
 */
export function coinFlipLines(flips) {
  return coinFlipGroups(flips).map(({ label, flips: group }) => `${label}: ${group.map(flip => (flip.heads ? 'heads' : 'tails')).join(', ')}`);
}

/**
 * A move's flips grouped by what they were for, in the order they were flipped: Sleeping Gas's coin, then the coin for
 * waking up between turns. Each flip keeps its place in the move's list (`index`).
 *
 * @param {Array<{label: string, heads: boolean}>} flips
 * @returns {Array<{label: string, flips: Array<{label: string, heads: boolean, index: number}>}>}
 */
export function coinFlipGroups(flips) {
  const byLabel = new Map();
  flips.forEach((flip, index) => {
    byLabel.set(flip.label, [...(byLabel.get(flip.label) || []), { ...flip, index }]);
  });
  return [...byLabel].map(([label, group]) => ({ label, flips: group }));
}
